/**
 * Shared analytics helpers — formatters, constants, and sub-components.
 */
import React from 'react';
import { Clock, CheckCircle, XCircle, AlertCircle } from 'lucide-react';

export const STATE_NAME_MAP = {
  'AL':'Alabama','AK':'Alaska','AZ':'Arizona','AR':'Arkansas','CA':'California',
  'CO':'Colorado','CT':'Connecticut','DE':'Delaware','FL':'Florida','GA':'Georgia',
  'HI':'Hawaii','ID':'Idaho','IL':'Illinois','IN':'Indiana','IA':'Iowa','KS':'Kansas',
  'KY':'Kentucky','LA':'Louisiana','ME':'Maine','MD':'Maryland','MA':'Massachusetts',
  'MI':'Michigan','MN':'Minnesota','MS':'Mississippi','MO':'Missouri','MT':'Montana',
  'NE':'Nebraska','NV':'Nevada','NH':'New Hampshire','NJ':'New Jersey','NM':'New Mexico',
  'NY':'New York','NC':'North Carolina','ND':'North Dakota','OH':'Ohio','OK':'Oklahoma',
  'OR':'Oregon','PA':'Pennsylvania','RI':'Rhode Island','SC':'South Carolina',
  'SD':'South Dakota','TN':'Tennessee','TX':'Texas','UT':'Utah','VT':'Vermont',
  'VA':'Virginia','WA':'Washington','WV':'West Virginia','WI':'Wisconsin','WY':'Wyoming'
};

export const COLORS = ['#4f46e5', '#06b6d4', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6'];

export function getHeatColor(value, maxValue) {
  if (!value || !maxValue) return '#f1f5f9';
  const ratio = value / maxValue;
  if (ratio < 0.2) return '#dcfce7';
  if (ratio < 0.4) return '#86efac';
  if (ratio < 0.6) return '#4ade80';
  if (ratio < 0.8) return '#22c55e';
  return '#16a34a';
}

export function StatusBar({ label, count, total, color, onClick }) {
  const pct = total > 0 ? (count / total) * 100 : 0;
  return (
    <div
      className="flex items-center gap-3 p-2 rounded-lg hover:bg-slate-50 cursor-pointer transition-colors"
      onClick={onClick}
      data-testid={`status-bar-${label.toLowerCase().replace(/ /g, '-')}`}
    >
      <div className="text-xs font-medium text-slate-600 w-32 truncate">{label}</div>
      <div className="flex-1 h-2 bg-slate-100 rounded-full overflow-hidden">
        <div className={`h-full ${color} rounded-full transition-all`} style={{ width: `${pct}%` }} />
      </div>
      <div className="text-xs font-bold text-slate-700 w-8 text-right">{count}</div>
      <div className="text-[10px] text-slate-400 w-12 text-right">{pct.toFixed(1)}%</div>
    </div>
  );
}

export function StatusBadge({ status }) {
  const configs = {
    draft: { bg: 'bg-slate-100', text: 'text-slate-700', icon: AlertCircle },
    pending_approval: { bg: 'bg-yellow-100', text: 'text-yellow-700', icon: Clock },
    pending_cfo_approval: { bg: 'bg-amber-100', text: 'text-amber-700', icon: Clock },
    pending_ceo_approval: { bg: 'bg-orange-100', text: 'text-orange-700', icon: Clock },
    approved: { bg: 'bg-green-100', text: 'text-green-700', icon: CheckCircle },
    rejected: { bg: 'bg-red-100', text: 'text-red-700', icon: XCircle }
  };
  const config = configs[status] || configs.draft;
  const Icon = config.icon;
  const displayStatus = (status || 'draft').replace(/_/g, ' ');
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${config.bg} ${config.text}`}>
      <Icon className="w-3 h-3" />
      {displayStatus}
    </span>
  );
}
